"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ToggleSwitch_1 = require("./ToggleSwitch");
exports.default = ToggleSwitch_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/ToggleSwitch/index.js
// module id = 1283
// module chunks = 8